import * as React from 'react';

const HorizontalDotsChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
        />
        <circle fillRule="evenodd" clipRule="evenodd" cx={12} cy={12} r={2} />
        <circle fillRule="evenodd" clipRule="evenodd" cx={6} cy={12} r={2} />
    </svg>
);

HorizontalDotsChunkySvg.displayName = 'HorizontalDotsChunkySvg';
export default HorizontalDotsChunkySvg;
